import { Component, Input } from "@angular/core";
import { TypeManagerDecorator } from "../main/type.map.service";

@TypeManagerDecorator("s25-ng-bubble")
@Component({
    standalone: true,
    selector: "s25-ng-bubble",
    template: `
        <div class="line {{ position }}">
            <div class="bubbleWrapper">
                <span class="bubble">
                    <ng-content></ng-content>
                </span>
            </div>
        </div>
    `,
    styles: `
        :host {
            /* Constant */
            --notch-size: 5px;

            /* Can be changed using CSS variables from ancestors */
            --color: var(--bubble-color, black);
            --background-color: var(--bubble-background-color, white);
            --border-width: var(--bubble-border-width, 1px);
            --border-style: var(--bubble-border-style, solid);
            --border-color: var(--bubble-border-color, black);
            --box-shadow: var(--bubble-box-shadow, 0 3px 7px rgba(0, 0, 0, 0.3));
            --max-width: var(--bubble-max-width);

            /* Computed */
            --border: var(--border-width) var(--border-style) var(--border-color);
            --notch-before-border: var(--notch-size) var(--border-style) var(--border-color);
            --notch-after-border: var(--notch-size) var(--border-style) var(--background-color);
            --notch-before-offset: calc(1px - var(--notch-size));
            --notch-after-offset: calc(2px - var(--notch-size));

            /* OTHER */
            display: block;
        }

        .line {
            width: 0;
            z-index: 2;
            height: 100%;
            color: var(--color);
            line-height: 1em;
        }

        .line .bubbleWrapper {
            position: absolute;
            width: max-content;
        }

        .line.up .bubbleWrapper {
            top: 0;
            transform: translate(-50%, calc(-100% - var(--notch-size)));
        }

        .line.down .bubbleWrapper {
            bottom: 0;
            transform: translate(-50%, calc(100% + var(--notch-size)));
        }

        .line.left .bubbleWrapper {
            left: 0;
            transform: translate(calc(-100% - var(--notch-size)), -50%);
        }

        .line.right .bubbleWrapper {
            right: 0;
            transform: translate(calc(100% + var(--notch-size)), -50%);
        }

        .line .bubbleWrapper::before,
        .line .bubbleWrapper::after {
            content: "";
            display: block;
            position: absolute;
        }

        .line:where(.up, .down) .bubbleWrapper::before,
        .line:where(.up, .down) .bubbleWrapper::after {
            border-left: var(--notch-size) solid transparent;
            border-right: var(--notch-size) solid transparent;
            left: calc(50% - var(--notch-size));
        }

        .line:where(.left, .right) .bubbleWrapper::before,
        .line:where(.left, .right) .bubbleWrapper::after {
            border-top: var(--notch-size) solid transparent;
            border-bottom: var(--notch-size) solid transparent;
            top: calc(50% - var(--notch-size));
        }

        .line.up .bubbleWrapper::before {
            border-top: var(--notch-before-border);
            bottom: var(--notch-before-offset);
        }

        .line.up .bubbleWrapper::after {
            border-top: var(--notch-after-border);
            bottom: var(--notch-after-offset);
        }

        .line.down .bubbleWrapper::before {
            border-bottom: var(--notch-before-border);
            top: var(--notch-before-offset);
        }

        .line.down .bubbleWrapper::after {
            border-bottom: var(--notch-after-border);
            top: var(--notch-after-offset);
        }

        .line.left .bubbleWrapper::before {
            border-left: var(--notch-before-border);
            right: var(--notch-before-offset);
        }

        .line.left .bubbleWrapper::after {
            border-left: var(--notch-after-border);
            right: var(--notch-after-offset);
        }

        .line.right .bubbleWrapper::before {
            border-right: var(--notch-before-border);
            left: var(--notch-before-offset);
        }

        .line.right .bubbleWrapper::after {
            border-right: var(--notch-after-border);
            left: var(--notch-after-offset);
        }

        .bubble {
            background: var(--background-color);
            padding: 2px;
            border: var(--border);
            display: block;
            border-radius: 3px;
            box-shadow: var(--box-shadow);
            max-width: var(--max-width);
            text-align: center;
            text-wrap: balance;
        }
    `,
})
export class S25BubbleComponent {
    @Input({ required: true }) position: BubblePosition;
}

export type BubblePosition = "up" | "down" | "left" | "right";
